// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { FlexRow, H3, OCBadge, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import { Icon } from 'opencare-crown';

// Other
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import ProfileImageCircles from '../../../../common/components/ProfileImageCircles/ProfileImageCircles';
import { selectDataClinic } from '../../../../profile/connect/selectors';

// Component
const ProviderCard = ({ provider, hasInsurance, inNetwork }) => {
  const clinic = useSelector(selectDataClinic);
  const { layout } = useWindowDimensions();
  return (
    <FlexRow
      aria-label="Provider"
      justify="space-between"
      align="flex-start"
      margin={`${
        layout === DIMENSIONS.MOBILE ? ' 15px 0 -.25em' : '15px 0 30px'
      }`}
    >
      <div>
        <H3
          fontSize="18px"
          margin={`${layout === DIMENSIONS.MOBILE ? '-.5em 0 1px' : '0'}`}
        >
          {provider.doctor.name}
        </H3>
        <P color="#6f6a71" margin="0 0 10px">
          {clinic.name}
        </P>
        {hasInsurance
        && (inNetwork
          ? (
            <OCBadge
              color={colors.sageDark}
              width="130px"
              margin={`${layout === DIMENSIONS.MOBILE ? '0 0 1em' : ''}`}
            >
              <Icon type="login" />
              In-Network
            </OCBadge>
          )

          : (
            <OCBadge
              color={colors.darkBlue}
              width="130px"
              margin={`${layout === DIMENSIONS.MOBILE ? '0 0 1em' : ''}`}
            >
              <Icon type="logout" />
              Out-of-network
            </OCBadge>
          )

        )}
      </div>
      <ProfileImageCircles
        height="50px"
        images={[
          { ...provider.doctor.primaryPhoto, altText: provider.doctor.name },
        ]}
        width="50px"
      />
    </FlexRow>
  );
};

ProviderCard.propTypes = {
  provider: PropTypes.object,
  hasInsurance: PropTypes.bool,
  inNetwork: PropTypes.bool,
};

export default ProviderCard;
